/**
 * A class represents predicted and actual employee capacity for a specific hour.
 */
export class EmployeeCapacity {
  hour: string;
  footfall: number;
  recommendedEmployee: number;
  assignedEmployee: number;

  /**
   * @param hour an hour.
   * @param footfall footfall prediction for a specific hour.
   * @param recommendedEmployee recommended employee prediction for a specific hour.
   * @param assignedEmployee the actual number of assigned employees for a specific hour.
   */
  constructor(hour: string, footfall: number, recommendedEmployee: number, assignedEmployee: number) {
    this.hour = hour;
    this.footfall = footfall;
    this.recommendedEmployee = recommendedEmployee;
    this.assignedEmployee = assignedEmployee;
  }

  /**
   * Returns true if there are more assigned employees than was predicted.
   */
  isOvercapacity(): boolean {
    return this.assignedEmployee > Math.ceil(this.recommendedEmployee);
  }

  /**
   * Returns true if there are fewer assigned employees than was predicted.
   */
  isUndercapacity(): boolean {
    return this.assignedEmployee < Math.ceil(this.recommendedEmployee);
  }
}
